import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneonewaycabservice() {



    const cardData = {

keyword: "Pune One Way Cab Service",

headingDescription:
    "Rising Cab Service offers affordable and reliable Pune One Way Cab Service for local and outstation travel. We provide convenient one-way taxi bookings for families, business travelers, tourists, and daily commuters with doorstep pickup and comfortable rides. Our fleet includes Sedan, SUV, Innova Crysta, Tempo Traveller, and Urbania vehicles driven by experienced chauffeurs. With transparent pricing, no return fare charges, 24/7 availability, and on-time service, Rising Cab Service ensures a safe and hassle-free one-way travel experience from Pune to major destinations across Maharashtra and India.",

topPlaces: [
    {
        title: "Mumbai",
        description:
            "Mumbai is the most popular one-way cab destination from Pune, famous for Gateway of India, Marine Drive, Juhu Beach, Siddhivinayak Temple, and major business districts. One-way cabs are ideal for business and leisure travelers."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is a renowned pilgrimage destination dedicated to Sai Baba. Devotees frequently choose one-way cab services from Pune for comfortable and convenient darshan trips."
    },
    {
        title: "Lonavala",
        description:
            "Lonavala is a scenic hill station known for Bhushi Dam, Tiger Point, waterfalls, and lush green valleys. It is one of the most preferred short-distance one-way cab routes from Pune."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a beautiful hill station famous for strawberry farms, Venna Lake, and breathtaking viewpoints, making it a popular family and holiday destination."
    },
    {
        title: "Goa",
        description:
            "Goa is one of India's top tourist destinations known for beaches, churches, nightlife, forts, and water sports. Many travelers prefer one-way road trips from Pune to Goa."
    },
    {
        title: "Nashik",
        description:
            "Nashik is a spiritual and cultural city known for Trimbakeshwar Jyotirlinga, Panchvati, Godavari Ghats, and vineyards, attracting pilgrims and tourists throughout the year."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is famous for the Mahalakshmi Temple, Panhala Fort, traditional cuisine, and rich Maratha heritage, making it a frequently booked one-way cab destination."
    },
    {
        title: "Aurangabad",
        description:
            "Aurangabad is home to the UNESCO World Heritage Sites of Ajanta and Ellora Caves, Bibi Ka Maqbara, and Daulatabad Fort, offering a memorable historical journey."
    },
    {
        title: "Pandharpur",
        description:
            "Pandharpur is a sacred pilgrimage destination dedicated to Lord Vitthal and Goddess Rukmini. Devotees often book one-way cabs from Pune for spiritual visits."
    },
    {
        title: "Alibaug",
        description:
            "Alibaug is a charming coastal destination known for its beaches, sea forts, and peaceful atmosphere. It is a popular one-way weekend getaway from Pune."
    }
],



services: [
    {
        name: "Pune One Way Cab Service",
        description:
            "Rising Cab Service provides Pune One Way Cab Service for convenient and affordable single-trip travel across Pune and major outstation destinations. Whether you need a cab for business travel, family trips, airport transfers, or intercity journeys, our one-way service eliminates unnecessary return charges and offers cost-effective transportation. We provide clean AC vehicles, experienced drivers, transparent pricing, instant booking, and 24x7 customer support for a comfortable and hassle-free travel experience."
    },
    {
        name: "One Way Taxi Pune",
        description:
            "Book One Way Taxi Pune with Rising Cab Service for safe and economical travel to local and outstation destinations. Our service is ideal for passengers looking for a single-direction trip with professional drivers, comfortable vehicles, and competitive pricing."
    },
    {
        name: "One Side Cab Pune",
        description:
            "Rising Cab Service offers One Side Cab Pune for passengers who need a one-time drop without paying for a return journey. We provide affordable fares, reliable drivers, and comfortable vehicles for city and intercity travel."
    },
    {
        name: "Drop Taxi Pune",
        description:
            "Our Drop Taxi Pune service provides quick and reliable point-to-point transportation for airport transfers, railway station drops, office commutes, and outstation travel with affordable pricing."
    },
    {
        name: "Intercity One Way Cab Pune",
        description:
            "Rising Cab Service offers Intercity One Way Cab Pune for comfortable travel to Mumbai, Nashik, Shirdi, Goa, Kolhapur, Aurangabad, and other destinations with professional chauffeurs and transparent fares."
    },
    {
        name: "Pune to City One Way Taxi",
        description:
            "Book Pune to City One Way Taxi with Rising Cab Service for affordable and convenient transportation to nearby cities and towns with multiple vehicle options and dependable service."
    },
    {
        name: "One Way Cab Booking Pune",
        description:
            "Our One Way Cab Booking Pune service allows customers to reserve cabs instantly or in advance for local and outstation travel with easy booking and fair pricing."
    },
    {
        name: "Affordable One Way Cab Pune",
        description:
            "Rising Cab Service provides Affordable One Way Cab Pune with budget-friendly fares and comfortable vehicles for single-direction travel without hidden charges."
    },
    {
        name: "Cheap One Way Taxi Pune",
        description:
            "Book Cheap One Way Taxi Pune with Rising Cab Service for economical travel solutions suitable for business trips, family journeys, and airport transfers."
    },
    {
        name: "Best One Way Cab Pune",
        description:
            "Our Best One Way Cab Pune service combines safety, affordability, and comfort with experienced drivers and well-maintained vehicles for reliable transportation."
    },
    {
        name: "One Way Outstation Cab Pune",
        description:
            "Rising Cab Service offers One Way Outstation Cab Pune for long-distance travel with affordable fares and comfortable rides to popular destinations across Maharashtra and India."
    },
    {
        name: "Long Distance One Way Taxi Pune",
        description:
            "Our Long Distance One Way Taxi Pune service provides convenient and safe transportation for extended journeys with professional drivers and multiple vehicle choices."
    },
    {
        name: "Sedan One Way Cab Pune",
        description:
            "Rising Cab Service provides Sedan One Way Cab Pune with spacious and comfortable vehicles suitable for individuals, couples, and small families."
    },
    {
        name: "SUV One Way Taxi Pune",
        description:
            "Book SUV One Way Taxi Pune for group travel and extra luggage capacity with comfortable and well-maintained SUVs driven by experienced chauffeurs."
    },
    {
        name: "Instant One Way Cab Pune",
        description:
            "Our Instant One Way Cab Pune service offers quick cab allocation and fast pickups for urgent travel requirements with dependable customer support."
    },
    {
        name: "One Way Cab Pune",
        description:
            "Rising Cab Service offers One Way Cab Pune for local and outstation travel with transparent pricing, professional drivers, and flexible booking options."
    },
    {
        name: "One Way Taxi Service Pune",
        description:
            "Our One Way Taxi Service Pune ensures safe, affordable, and comfortable single-trip travel for personal, business, and family transportation needs."
    },
    {
        name: "Pune One Side Cab Booking",
        description:
            "Book Pune One Side Cab Booking with Rising Cab Service for economical travel without return charges and enjoy a comfortable ride with experienced drivers."
    },
    {
        name: "Best One Way Cab in Pune",
        description:
            "Rising Cab Service provides one of the Best One Way Cab in Pune with affordable fares, quality vehicles, and reliable transportation for all travel requirements."
    },
    {
        name: "Cheap One Way Cab Pune",
        description:
            "Our Cheap One Way Cab Pune service offers low-cost travel solutions with clean vehicles, professional chauffeurs, and transparent pricing."
    },
    {
        name: "Online One Way Cab Booking Pune",
        description:
            "Rising Cab Service offers Online One Way Cab Booking Pune with instant confirmation, easy reservations, and flexible travel scheduling."
    },
    {
        name: "24x7 One Way Taxi Pune",
        description:
            "Book 24x7 One Way Taxi Pune with Rising Cab Service for reliable transportation any time of the day or night with comfortable vehicles and prompt service."
    },
    {
        name: "Outstation One Way Cab Pune",
        description:
            "Our Outstation One Way Cab Pune service provides affordable and convenient travel to destinations like Mumbai, Shirdi, Nashik, Goa, and Mahabaleshwar."
    },
    {
        name: "Pune to Mumbai One Way Cab",
        description:
            "Rising Cab Service offers Pune to Mumbai One Way Cab with comfortable AC vehicles, experienced highway drivers, and affordable pricing for business and leisure travel."
    },
    {
        name: "Airport One Way Cab Pune",
        description:
            "Our Airport One Way Cab Pune service provides convenient airport pickups and drops with timely service, affordable fares, and professional drivers."
    },
    {
        name: "Best One Way Cab Service Near Me Pune",
        description:
            "Looking for the Best One Way Cab Service Near Me Pune? Rising Cab Service provides dependable one-way transportation with multiple vehicle options and competitive pricing."
    },
    {
        name: "Cheap One Way Taxi Pune",
        description:
            "Rising Cab Service offers Cheap One Way Taxi Pune for affordable local and outstation travel with safe drivers and comfortable vehicles."
    }
],

tableData: [
    ["Pune One Way Cab Service", "One Way Taxi Pune"],
    ["One Side Cab Pune", "Drop Taxi Pune"],
    ["Intercity One Way Cab Pune", "Pune to City One Way Taxi"],
    ["One Way Cab Booking Pune", "Affordable One Way Cab Pune"],
    ["Cheap One Way Taxi Pune", "Best One Way Cab Pune"],
    ["One Way Outstation Cab Pune", "Long Distance One Way Taxi Pune"],
    ["Sedan One Way Cab Pune", "SUV One Way Taxi Pune"],
    ["Instant One Way Cab Pune", "One Way Cab Pune"],
    ["One Way Taxi Service Pune", "Pune One Side Cab Booking"],
    ["Best One Way Cab in Pune", "Cheap One Way Cab Pune"],
    ["Online One Way Cab Booking Pune", "24x7 One Way Taxi Pune"],
    ["Outstation One Way Cab Pune", "Pune to Mumbai One Way Cab"],
    ["Airport One Way Cab Pune", "Best One Way Cab Service Near Me Pune"],
    ["Cheap One Way Taxi Pune", "One Way Cab Booking Pune"]
],




whychoose: [
    {
        WhyChooseheading: "Dedicated One Way Cab Services from Pune",
        WhyChoosedescription: "Rising Cab Service provides convenient one-way cab solutions from Pune to major cities, pilgrimage destinations, tourist attractions, airports, and business hubs across India."
    },
    {
        WhyChooseheading: "Pay Only for Your Journey",
        WhyChoosedescription: "Our one-way travel option helps customers avoid unnecessary return-trip expenses, making travel more economical and efficient."
    },
    {
        WhyChooseheading: "Perfect for Business and Personal Travel",
        WhyChoosedescription: "Whether traveling for work, family visits, airport transfers, medical appointments, or vacations, our one-way cab service offers flexibility and convenience."
    },
    {
        WhyChooseheading: "Wide Selection of Travel Vehicles",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to your travel requirements."
    },
    {
        WhyChooseheading: "Popular Routes Covered from Pune",
        WhyChoosedescription: "We provide one-way taxi services from Pune to Mumbai, Nashik, Shirdi, Kolhapur, Aurangabad, Lonavala, Mahabaleshwar, Goa, and many other destinations."
    },
    {
        WhyChooseheading: "Doorstep Pickup Convenience",
        WhyChoosedescription: "Passengers can enjoy pickup services from homes, hotels, offices, Pune Airport, Railway Station, and all major Pune and PCMC locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Long Routes",
        WhyChoosedescription: "Our skilled drivers are familiar with highways, city routes, and interstate travel, ensuring a safe and comfortable journey."
    },
    {
        WhyChooseheading: "Simple Booking and Travel Process",
        WhyChoosedescription: "Rising Cab Service makes one-way travel easy with quick booking assistance, transparent communication, and dependable transportation."
    }
]
};

const faqData = [
    {
        question: "What is a Pune One Way Cab Service?",
        answer: "A one-way cab service allows passengers to travel from Pune to their destination without paying for a return journey."
    },
    {
        question: "Which destinations can be covered through one-way cab bookings?",
        answer: "Popular destinations include Mumbai, Nashik, Shirdi, Aurangabad, Kolhapur, Goa, Lonavala, Mahabaleshwar, and many other cities."
    },
    {
        question: "Who typically chooses one-way cab services?",
        answer: "Business travelers, tourists, students, families, and individuals relocating often prefer one-way transportation."
    },
    {
        question: "Can airport and railway station transfers be booked as one-way trips?",
        answer: "Yes, one-way transfers are available for Pune Airport, Railway Stations, hotels, offices, and residential locations."
    },
    {
        question: "Which vehicle options are available for one-way travel?",
        answer: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
    },
    {
        question: "Are same-day one-way bookings available?",
        answer: "Yes, subject to vehicle availability, same-day travel bookings can be arranged."
    },
    {
        question: "Can families book larger vehicles for one-way journeys?",
        answer: "Yes, spacious vehicles and group travel options are available for families and larger groups."
    },
    {
        question: "Is advance reservation beneficial for one-way trips?",
        answer: "Yes, advance booking helps secure preferred vehicle options and smoother travel planning."
    },
    {
        question: "Can customers travel to another state using a one-way cab?",
        answer: "Yes, interstate one-way travel can be arranged for various destinations across India."
    },
    {
        question: "How can I book a Pune One Way Cab Service?",
        answer: "You can reserve your cab through phone, WhatsApp, or online inquiry with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Ajinkya Shinde",
        feedback:
            "Traveling from Pune to Mumbai became extremely convenient with the one-way cab option. The journey was smooth, and the vehicle arrived exactly on schedule.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Tejaswini More",
        feedback:
            "For a recent family trip, the one-way service was both practical and comfortable. The booking process was simple, and the overall travel experience was excellent.",
        rating: 5
    }
];








    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];









const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune One Way Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-one-way-cab-service.jpg",
"description": "Book Pune One Way Cab Service with Rising Cab Service for affordable intercity travel, outstation drop trips, and long-distance one-side journeys. Enjoy safe, reliable, and budget-friendly one-way taxi service with AC sedans and SUVs.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-one-way-cab-service"
}
};








    return (
        <div>


<Helmet>
  <title>Pune One Way Cab Service | Drop Taxi & Outstation Ride | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune One Way Cab Service for affordable drop taxis, intercity travel, and outstation one-side trips. Get cheap and reliable one-way cab booking in Pune with AC sedans and SUVs."
/>

<meta
 name="keywords"
 content="Pune one way cab service, one way taxi pune, one side cab pune, drop taxi pune, intercity one way cab pune, pune to city one way taxi, one way cab booking pune, affordable one way cab pune, cheap one way taxi pune, best one way cab pune, one way outstation cab pune, long distance one way taxi pune, sedan one way cab pune, suv one way taxi pune, instant one way cab pune, Pune One Way Cab Service, One Way Cab Pune, One Way Taxi Service Pune, Pune One Side Cab Booking, Best One Way Cab in Pune, Cheap One Way Cab Pune, Online One Way Cab Booking Pune, 24x7 One Way Taxi Pune, Outstation One Way Cab Pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/31.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Puneonewaycabservice;